import { j as r } from "../../../../_virtual/jsx-runtime.js";
import { forwardRef as p } from "react";
import s from "../../SkeletonWrapper/index.js";
import { cn as a } from "../../../../lib/utils.js";
import { heightStyles as i, baseStyles as f } from "../styles.js";
const l = p(
  ({ isLoading: t, className: e, ...o }, m) => /* @__PURE__ */ r.jsx(s, { full: !0, isLoading: t, children: /* @__PURE__ */ r.jsx(
    "input",
    {
      ref: m,
      className: a(f, i, e),
      ...o
    }
  ) })
);
l.displayName = "Input";
export {
  l as default
};
